import * as React from 'react';

import Spinner from 'components/spinner/spinner.component';

import { ICheckBetaInfoProps } from './check-friends-referral-info.types';

class CheckFriendsReferralInfo extends React.Component<ICheckBetaInfoProps> {
    public componentDidMount() {
        const { isReferrer, gotFriendsReferralInfo, hasOwnershipOnAnyPlatform } = this.props;
        gotFriendsReferralInfo({
            isReferrer,
            hasOwnershipOnAnyPlatform
        });
    }

    public render(): JSX.Element {
        return <Spinner />;
    }
}

export default CheckFriendsReferralInfo;
